const riot = require('riot');

riot.tag2('page-members', '<div class="s-full f"> <div class="flex-fixed" data-is="module-sidebar"></div> <div class="flex-auto f fclm w0 h-full bg-pale_gray"> <div class="bg-white flex-fixed" data-is="module-page-header" title="メンバー管理"></div> <div class="f fclm flex-auto h0 w-full py36 px40"> <div class="f fclm w-full flex-height-auto bg-white rounded-8 elevation-default-mid"> <form class="flex-fixed pt32 px32 mb24" onsubmit="{onInviteUser}"> <div class="mb36" data-is="module-section-header" title="メンバーの招待"> </div> <div class="f fm"> <label class="w-full block mr16"> <input class="input w-full" ref="email" required placeholder="例) help@repro.io" type="email"> </label> <div class="flex-fixed w200 mr16" data-is="atom-input-select" ref="role" options="{app.data.constants.project_roles}" riot-value="{app.data.constants.project_roles[0].id}"></div> <button class="button size-m flex-fixed">メンバーを招待</button> </div> </form> <div class="f fclm w-full flex-height-auto"> <div class="w-full flex-height-auto" data-is="module-table" schemas="{tableSchemas}" items="{projectUsers}" scroll-type="y"></div> <div class="flex-fixed f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div> </div>', '', '', function(opts) {
    this.tableSchemas = [
      {
        id: 'user.name',
        label: '名前',
        class: 'w220 flex-fixed',
      },
      {
        id: 'user.email',
        label: 'メールアドレス',
        class: 'w220 flex-fixed',
      },
      {
        id: 'role',
        label: '権限',
        class: 'min-width-220 w0 flex-auto',
        getText: (v) => app.utils.getProjectRoleLabel(v),
      },
      {
        id: 'user',
        component: 'material-icon-button',
        align: 'center',
        class: 'flex-fixed w48',
        text: 'more_vert',
        shouldShow: (item, e) => {
          return item.user.id !== app.utils.auth.currentUser.id;
        },
        onclick: (item, e) => {
          this.onOpenActionSheet(item, e);
        },
      },
    ];
    this.limit = 50;

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;

      var params = {
        limit: this.limit,
        offset: 0,
      };
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;

      var promises = [
        app.api.child(`companies/${companyId}/projects/${projectId}/users`).get(params),
      ];

      var [{ project_users, pagination }] = await Promise.all(promises);

      return {
        projectUsers: project_users,
        pagination,
        companyId,
        projectId,
      };
    };

    this.on('mount', () => {

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        try {
          var {project_users, pagination} = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users`).get({ limit: this.limit, offset });
          this.projectUsers = project_users;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });
    })

    this.head = () => {
      return {
        title: app.utils.head.title('メンバー管理', this),
      };
    };

    this.onInviteUser = async (e) => {
      e.preventDefault();
      try {
        var indicator = spat.modal.indicator();

        var query = {
          role: this.refs.role.getValue(),
          email: this.refs.email.value,
        };

        await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users`).post(query);

        var { project_users, pagination } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users`).get({ limit: this.limit, offset:0 });
        this.projectUsers = project_users;
        this.pagination = pagination;
        this.refs.email.value = '';
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onDeleteUser = async (item) => {
      var modal = await spat.modal.open('modal-confirm', {
        text: '削除しますか？',
      });
      var result = await modal.waitClose();
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users/${item.user.id}`).del({});
        var { project_users, pagination } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users`).get({ limit: this.limit, offset:0 });
        this.projectUsers = project_users;
        this.pagination = pagination;
        this.update();
        spat.modal.alert('メンバーを削除しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onOpenActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "pencil",
          label: "権限の変更",
          action: () => { popup.close(); this.openRoleChangeModal(item); },
        },
        {
          icon: "trash",
          label: "削除",
          action: () => { popup.close(); this.onDeleteUser(item); },
          alert: true
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.openRoleChangeModal = async (item) => {
      var buttons = [
        {
          type: 'button',
          text: 'キャンセル',
          class: 'text',
          onclick: () => modal.close(),
        },
        {
          type: 'submit',
          text: '変更',
          class: 'outline',
        },
      ];
      var query = {
        title: 'ロールを変更しますか？',
        items: app.data.constants.project_roles,
        current: item,
        buttons,
        submit: (v) => this.putUserRole(v, item),
      };

      var modal = await spat.modal.open('modal-select-radio', query);
    };

    this.putUserRole = async (value, item) => {
      var indicator = spat.modal.indicator();

      try {
        await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users/${item.user.id}`).put({ role: value });
        var { project_users, pagination } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/users`).get({ limit: this.limit, offset:0 });
        this.projectUsers = project_users;
        this.pagination = pagination;
        this.update();
        spat.modal.alert('更新しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});